import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalSmallFilled from '../../../../../ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../ModalsLayouts/types'



interface ModalConfirmChangeWorkingCenterProps extends ModalEditComponentProps {
    handleSelectedWorkingCenter: (WorkingCenterId?: number, WorkingCenterStationId?: number) => void
}

const ModalConfirmChangeWorkingCenter: React.FC<ModalConfirmChangeWorkingCenterProps> = ({ handleSelectedWorkingCenter, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    return (
        <ModalSmallFilled opened={true} setOpened={rest.setOpened} onAccept={() => handleSelectedWorkingCenter(allRowData?.WorkingCenterId, allRowData?.WorkingCenterStationId)} onCancel={() => { rest.setOpened(null)}} translations={{
            title: t('haveSelectedOtherWorkingCenter', 'Has seleccionado otro centro de trabajo'),
            subtitle: t('sureChangeWorkingCenterChangesSells', '¿Seguro que quieres cambiar de centro de trabajo? Esto tendrá consecuencias en los apartados de ventas'),
            buttonAccept: t('accept', 'Aceptar')
        }} />
    )
}

export default ModalConfirmChangeWorkingCenter